import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import GenericKP11CardSelectInput from '../kp-11-generic-cards/kp11-generic-card-select-input'
import {getKeapLegacyGraphlyContactsByCountry} from '../../../../../kp-shared-link/kp-sharedLink-utility/kp-utility'
import {
  buildCartEntity,
  countryCurrencyEnum,
} from '../../../../kp-11Link-utility/kp11-utility'
import {
  setKeapLegacyGraphlyContactsQuantity,
  setSelectedKeapLegacyGraphlyContactsOption,
  selectKeapLegacyGraphlyContactsOption,
  selectKeapLegacyGraphlyContactsQuantity,
  selectKP11SelectCartCentersNApps,
} from '../../../../../../../app-store/kp11CartSlice'

const KP11KeapLegacyGraphlyContacts = ({
  name,
  price,
  isChecked,
  groupKey,
  itemCode,
  selectedCountry,
  onAddToCart,
  item,
  section,
  billingType,
}) => {
  const dispatch = useDispatch()
  const [isExpanded, setIsExpanded] = useState(isChecked)
  const countryCurrency = countryCurrencyEnum[selectedCountry]
  const keapLegacyGraphlyContactsOption = useSelector(
    selectKeapLegacyGraphlyContactsOption,
  )
  const keapLegacyGraphlyContactsQuantity = useSelector(
    selectKeapLegacyGraphlyContactsQuantity,
  )
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const [selectedOptionValue, setSelectedOptionValue] = useState(
    keapLegacyGraphlyContactsOption,
  )

  useEffect(() => {
    setSelectedOptionValue(keapLegacyGraphlyContactsOption)
  }, [keapLegacyGraphlyContactsOption])

  useEffect(() => {
    setIsExpanded(isChecked)
  }, [isChecked])

  // Disable Add to Cart when selected tier matches existing
  const existingApp = cartCentersAndApps?.apps?.find(
    app => app.code === itemCode,
  )
  const selectedAmount = selectedOptionValue
    ? parseFloat(selectedOptionValue.split('-')[1])
    : NaN
  const existingAmount = Number(
    existingApp?.unitAmount ?? existingApp?.amount ?? 0,
  )
  const isSameTierSelected =
    existingApp?.isAlreadyAdded &&
    selectedOptionValue &&
    Number.isFinite(selectedAmount) &&
    Number.isFinite(existingAmount) &&
    Math.abs(selectedAmount - existingAmount) < 0.01

  // Filter options to prevent downgrade
  const allOptions = getKeapLegacyGraphlyContactsByCountry(
    selectedCountry,
    billingType,
  )
  const options =
    keapLegacyGraphlyContactsQuantity > 0
      ? allOptions.filter(
          opt =>
            Number(opt.value.split('-')[0]) >=
            Number(keapLegacyGraphlyContactsQuantity),
        )
      : allOptions

  const handleSelected = value => {
    setSelectedOptionValue(value)
    dispatch(setSelectedKeapLegacyGraphlyContactsOption(value))
  }

  const handleSave = () => {
    if (!selectedOptionValue) {
      return
    }
    // Skip if selecting same tier as existing
    if (existingApp?.isAlreadyAdded) {
      const selectedAmount = parseFloat(selectedOptionValue.split('-')[1])
      const existingAppAmount =
        existingApp.unitAmount ?? existingApp.amount ?? 0
      const existingAmount = Number(existingAppAmount)
      if (
        Number.isFinite(selectedAmount) &&
        Number.isFinite(existingAmount) &&
        Math.abs(selectedAmount - existingAmount) < 0.01
      ) {
        return
      }
    }
    dispatch(
      setKeapLegacyGraphlyContactsQuantity(
        parseFloat(selectedOptionValue.split('-')[0]).toFixed(2),
      ),
    )
    const updatedItem = buildCartEntity({
      kind: 'item',
      source: {
        ...item,
        currencies: item.currencies.map(currencyInfo => {
          if (currencyInfo.currency === countryCurrency) {
            return {
              ...currencyInfo,
              unitAmount: parseFloat(selectedOptionValue.split('-')[1]).toFixed(
                2,
              ),
            }
          }
          return currencyInfo
        }),
        groupKey,
        section,
      },
    })

    onAddToCart(updatedItem, selectedOptionValue)
  }

  return (
    <GenericKP11CardSelectInput
      name={name}
      billingType={billingType}
      label="Select quantity"
      placeholder="Choose contacts amount"
      groupKey={groupKey}
      itemCode={itemCode}
      isExpanded={isExpanded}
      value={selectedOptionValue}
      options={options}
      onClick={() => {
        setIsExpanded(true)
      }}
      onSelect={handleSelected}
      onSave={handleSave}
      addToCartDisabled={isSameTierSelected}
      selectedCountry={selectedCountry}
    />
  )
}

export default KP11KeapLegacyGraphlyContacts
